import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=2a83989e&lang=pug&"
import script from "./ChatItem.ts?vue&type=script&lang=js&"
export * from "./ChatItem.ts?vue&type=script&lang=js&"
import style0 from "./ChatItem.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports